import { getGraphqlClient } from "@/api/graphql/client.ts";
import { BillingMsSearchTidLinkedAccountsRequestSortField } from "@/api/graphql/types/graphql.ts";
import { PAGINATION } from "@/constants/constants.ts";

import { fromApiToTidLinkedAccounts } from "./mappers.ts";
import { SearchTidLinkedAccountsQuery } from "./queries.ts";
import { GetTidLinkedAccountsParams } from "./types.ts";

export const getTidLinkedAccounts = async ({
  filters,
  paging,
}: GetTidLinkedAccountsParams) => {
  const graphqlClient = getGraphqlClient();

  const response = await graphqlClient.request(SearchTidLinkedAccountsQuery, {
    request: {
      filters: {
        accountId: filters.accountId,
        typeIds: filters.typeIds,
      },
      paging: {
        page: paging.page || PAGINATION.DEFAULT_FIRST_PAGE,
        size: paging.size || PAGINATION.DEFAULT_PER_PAGE,
      },
      sorts: [
        {
          ascending: false,
          field: BillingMsSearchTidLinkedAccountsRequestSortField.UpdatedTs,
        },
      ],
    },
  });

  return {
    items: fromApiToTidLinkedAccounts(response),
    pagination: response.BillingMsSearchTidLinkedAccounts.pagination,
  };
};
